export default __webpack_public_path__ + "static/media/LaNuitChoristes.afc10be9.mp3";